<template>
  <div class="monster-card">
    <div class="notification" :class="monsterClass">
      <button class="delete" @click="deleteMonster()"></button>
      <div class="monster-line">
        <form v-if="!!editingName" class="has-text-dark">
          <input type="text" class="input" v-model="monster.name">
          <button class="button is-text" type="submit" @click.prevent="confirmName()">
            <span class="icon">
              <i class="fas fa-check fa-sm"></i>
            </span>
          </button>
        </form>
        <div v-else class="monster-name has-text-weight-semibold">
          {{ monster.name }}
          <button class="button is-text is-small" @click.prevent="editName()">
            <span class="icon">
              <i class="fas fa-pencil-alt"></i>
            </span>
          </button>
        </div>
        <div class="monster-init">
          <span class="icon is-medium">
            <i class="fas fa-dice-d20 fa-sm"></i>
          </span>
          <span class="has-text-weight-semibold">{{ monster.initiative }}</span>
        </div>
      </div>
      <div v-if="monster.hp" class="monster-line">
        <div class="monster-control">
          <div class="field has-addons">
            <p class="control">
              <button class="button is-danger is-light is-small" @click.prevent="adjustHp(-1)">Damage</button>
            </p>
            <p class="control">
              <input type="number" inputmode="numeric" pattern="[0-9]*" class="input is-small" v-model="damage"/>
            </p>
            <p class="control">
              <button class="button is-success is-light is-small" @click.prevent="adjustHp(1)">Heal</button>
            </p>
          </div>
        </div>
        <div class="monster-hp">
          <span class="icon">
            <i class="fas fa-heart fa-sm"></i>
          </span>
          <span>{{ monster.hp }}</span>
        </div>
      </div>
      <div v-if="hasDetails" class="monster-line monster-details">
        <p v-if="monster.proficiency">
          <strong>Prof. Bonus:</strong> 
          <span>{{ formatBonus(monster.proficiency) }}</span>
        </p>
        <p v-if="monster.armorClass">
          <strong>AC:</strong> 
          <span>{{ monster.armorClass }}</span>
        </p>
        <p v-if="monster.attackBonus">
          <strong>Attack Bonus:</strong> 
          <span>{{ formatBonus(monster.attackBonus) }}</span>
        </p>
        <p v-if="monster.saveDc">
          <strong>Save DC:</strong> 
          <span>{{ monster.saveDc }}</span>
        </p>
        <p v-if="monster.rating">
          <strong>CR:</strong> 
          <span>{{ monster.rating }}</span>
        </p>
        <p v-if="monster.damagePerRound">
          <strong>Damage/Round:</strong> 
          <span>{{ monster.damagePerRound }}</span>
        </p>
      </div>
      <Conditions 
      :campaignId="campaignId" 
      collection="monsters" 
      :id="monsterId"/>
    </div>
  </div>
</template>
<script>
import { db } from '../main'
import Conditions from '../components/Conditions.vue'

export default {
  name: 'MonsterCard',
  props: {
    campaignId: String,
    monsterId: String,
  },
  data () {
    return {
      monster: {},
      damage: null,
      editingName : false,
    }
  },
  firestore () {
    // return {
    //   campaign: db.collection('campaigns').doc(this.id)
    // }
    this.$bind('monster', db.collection('campaigns').doc(this.campaignId).collection('monsters').doc(this.monsterId))
  },
  computed: {
    monsterClass () {
      if(this.monster.hp !== false) {
        return (this.monster.hp > 0) ? 'is-link' : 'is-dead'
      }
      else {
        return 'is-link'
      }
    },
    hasDetails () {
      if (this.monster.rating || this.monster.proficiency || this.monster.armorClass || this.monster.attackBonus || this.monster.damagePerRound || this.monster.saveDc) {
        return true
      }
      else {
        return false
      }
    }
  },
  methods: {
    updateMonster () {
      this.monster.name = this.titleCase(this.monster.name)
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection('monsters')
        .doc(this.monsterId)
        .update(this.monster)
        .then(() => {
          console.log('monster updated!')
        })
    },
    editName () {
      this.editingName = true
    },
    confirmName () {
      this.updateMonster()
      this.editingName = false
    },
    adjustHp (multiplier) {
      if (!this.damage) return

      const hpMax = parseInt(this.monster.hpMax)
      const damage = parseInt(this.damage) * multiplier
      let hitpoints = parseInt(this.monster.hp) + damage
      if (hitpoints > hpMax) {
        console.log('full health!')
        hitpoints = hpMax
      }
      // const hitpoints = (newHp > 0) ? newHp : 0
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection('monsters')
        .doc(this.monsterId)
        .update({
          hp: hitpoints
        })
        .then(() => {
          console.log('monster hp updated!')
          this.damage = null
        })
    },
    deleteMonster () {
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection('monsters')
        .doc(this.monsterId)
        .delete()
        .then(() => {
          console.log('monster deleted!')
        })
    },
    formatBonus (num) {
      return (num >= 0) ? `+${num}` : num
    }
  },
  components: {
    Conditions
  }
}
</script>
<style scoped>
.notification {
  /* background: rgba(204, 204, 0, 0.39);
  border: 4px solid #CCCC00; */
  /* background-color: var(--brand-yellow-green); */
  border-radius: 10px;
}
input {
  color: #4a4a4a;
}
@media screen and (min-width: 769px) {
  .monster-card {
    margin-left: -32px;
  }
  .notification {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
  }
}
@media screen and (max-width: 769px) {
  .monster-card {
    margin-right: -32px;
  }
  .notification {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }
}
.is-dead .monster-hp, 
.is-dead .monster-name,
.is-dead .monster-init {
  color: #bbb;
}
.is-dead .monster-control {
  opacity: 0.75;
}
.is-dead .monster-name {
  text-decoration: line-through;
}
.is-dead .monster-name .icon {
  display: none;
}
.monster-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  font-size: 1.25em;
}
.monster-line {
  margin-bottom: 0.25em;
}
@media screen and (min-width: 769px) {
  .monster-line {
    font-size: 1.4em;
  }
}
.monster-init {
  margin-left: auto;
}
.monster-control {
  margin-right: auto;
  /* margin-left: 0.5em; */
}
.monster-control input {
  max-width: 70px;
}
.button.is-text {
  color: inherit;
}
/* .monster-line:last-child {
  padding-bottom: 0.5em;
  justify-content: center;
} */
form, 
.monster-name {
  display: flex;
  align-items: center;
}
.button.is-text {
  text-decoration: none;;
}
.monster-line.monster-details {
  font-size: 0.95em;
  justify-content: flex-start;
  padding: 0.25em 0.5em;
  border-radius: 5px;
  background-color: rgba(0,0,0,0.05);
  box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
}
.monster-details p:not(:last-child) {
  padding-right: 1.5em;
}
.monster-details span {
  border: 1px solid rgba(255,255,255,0.3);
  padding: 0 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/MonsterCard.vue